import { generateClient } from "aws-amplify/api";
import { FormTemplateForResolver } from "db/definitions";
import { batchAddFormTemplates } from "graphql/mutations";
import { recordSentry } from "utils/recordSentry";

async function batchCreateFormTemplates(formTemplates: FormTemplateForResolver[]): Promise<boolean> {
	if (formTemplates.length > 0) {
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchAddFormTemplates,
				variables: { formTemplates },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			recordSentry({ error });
		}
		return false;
	}
	return true;
}

export default batchCreateFormTemplates;
